export const nodata = '-'